/* Geometria da pista — parâmetros vêm do MapCatalog (mapa ativo).
 * Fallback: anel em torno de (0,0), sentido ANTI-HORÁRIO no plano x-z.
 * Linha de largada/chegada em z≈startZ (x na faixa) -> startAngle.
 * Progresso = ângulo acumulado (desenrolado) a partir da linha: 0 = linha, 2π = 1 volta. */
import mapCatalog from '../Content/MapCatalog.js'

export const TAU = Math.PI * 2

/** Snapshot estático inicial (compat). Prefira getTrack() em runtime. */
export const TRACK = {
    radius: 50,
    startAngle: Math.atan2(11.5, 50),
    bandMin: 38,
    bandMax: 62,
}

/** Parâmetros do mapa ativo (sempre atualizado). */
export function getTrack() {
    const a = mapCatalog.active
    return {
        radius: a.radius,
        startAngle: a.startAngle,
        bandMin: a.bandMin,
        bandMax: a.bandMax,
        startZ: a.startZ,
        laps: a.laps,
        id: a.id,
        name: a.name,
    }
}

export function wrapAngle(a) {
    a = (a + Math.PI) % TAU
    if (a < 0) a += TAU
    return a - Math.PI
}

/** Posição de largada: grid 2 colunas ATRÁS da linha, apontando no sentido da corrida. */
export function gridPose(slot) {
    const T = getTrack()
    const row = Math.floor(slot / 2)
    const col = slot % 2
    const theta = T.startAngle - (0.10 + row * 0.14 + (col ? 0.05 : 0))
    const R = T.radius + (col === 0 ? -3.5 : 3.5)
    return { x: R * Math.cos(theta), z: R * Math.sin(theta), yaw: -theta }
}

/** Pose no centro da pista para um progresso total (usado no respawn). */
export function poseAtProgress(total) {
    const T = getTrack()
    const theta = T.startAngle + total
    return { x: T.radius * Math.cos(theta), z: T.radius * Math.sin(theta), yaw: -theta }
}
